import React from 'react';
import PropTypes from 'prop-types';
import Isvg from 'react-inlinesvg';
import store from '../../store';
import ContentContainer from '../ContentContainer';

class CheckoutHeader extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            steps: props.steps,
            current: props.current || 0,
        };
    }

    componentWillReceiveProps(nextProps) {
        if (this.props.current !== nextProps.current) {
            this.setState({ current: nextProps.current });
        }
    }

    renderSteps() {
        const steps = [];
        this.state.steps.forEach((step, i) => {
            let cn = '';
            let icon = '';

            if (this.state.current === i) {
                cn = 'is-active';
            } else if (this.state.current > i) {
                cn = 'is-done';
                icon = <Isvg src="/svg/icon-check-small.svg" className="checkout-header__icon" />;
            }
            steps.push(
                <li key={i} className={cn} data-step={i + 1}>
                    {icon}
                    <span>{step}</span>
                </li>
            );
        });

        return <ul className="checkout-header__progress">{steps}</ul>;
    }

    render() {
        return (
            <div className="checkout-header">
                <ContentContainer>
                    <div className="checkout-header__inner">
                        {this.props.children}
                        {this.renderSteps()}
                    </div>
                </ContentContainer>
            </div>
        );
    }
}

CheckoutHeader.propTypes = {
    steps: PropTypes.array.isRequired,
    current: PropTypes.number,
    children: PropTypes.node,
};

CheckoutHeader.defaultProps = {};

export default CheckoutHeader;
